import {
  PlannerAction
} from "src/components/Planner/planner/history/planner-action";
import {
  hideTools,
  MEASURE_TYPES,
  unHighlight,
} from "src/components/Planner/planner/planner";
import {PlannerGlobals} from "src/components/Planner/planner/planner-globals";
import $ from "jquery";
import {ts} from "src/utils/translate"
import {
  getDeviceById,
  getGroupOfDevice,
  getGroupsOfDevice,
  getSerialById,
  isDevChangeInProgress
} from "src/components/Planner/planner/uDev";
import {
  getProductOfDevice,
  modDevNote,
  sendDevNoteAuto
} from "src/components/Planner/planner/uDev-dom";
import {
  addDevToGroupNoCheck,
  groupIsControlledByNSwitches,
  makeNewGroupNoCheck
} from "src/components/Planner/planner/grouping";
import {
  wallModHelperDOM
} from "src/components/Planner/planner/wallModHelper-dom";
import {
  placeDevice,
  redrawDevices
} from "src/components/Planner/planner/deviceDrawing";
import {
  getSerialConnectionForSerialId
} from "src/components/Planner/planner/serialConnections";
import {
  ajaxSetSerialProps,
  connectSerials,
  placeSerialDevices
} from "src/components/Planner/planner/serialConnections-dom";

import {
  deepCopy,
  removeProgressBar,
  setProgressBarState,
  startLoading,
  stopLoading,
  toastError,
  toastInfoSingle,
  toastRemoveAll
} from "src/components/Planner/controller";
import {GlobalsVariables} from "src/utils/constants";
import {
  addMeasurementAjax,
  measureTypeById_T
} from "src/components/Planner/planner/measurement";
import {
  refreshFloorView
} from "src/components/Planner/planner/plannerCacheInvalidation";

/**
 * Calls the specified function with the given parameter
 * @param {function} fn
 * @param {any} val
 */
export function callIfFn(fn, val) {
  if (typeof fn === "function") {
    fn(val);
  }
}

export class PlannerHistoryManager {
  constructor() {
    /**
     * @type {PlannerAction[]}
     */
    this.history = [];
    this.historyIdx = -1;
    this.busy = false;
    this.handleButtonClasses();
    this.debug = GlobalsVariables.env === "dev";
  }

  handleButtonClasses() {
    /* $('#planner-history-reset-btn').addClass('hidden'); */
    $('#planner-undo-btn, #planner-redo-btn').removeClass('planner-button-disabled');
    if (this.busy) {
      $('#planner-undo-btn, #planner-redo-btn').addClass('planner-button-disabled');
    }
    else {
      $('.planner-buttons-cont').find('.tooltip').hide();

      var undoTxt = ts('p_undo', 'Undo');
      if (this.historyIdx === -1) {
        $('#planner-undo-btn').addClass('planner-button-disabled');
      }
      else {
        undoTxt += " (" + this.history[this.historyIdx].actionName + ")";
      }
      $('#planner-undo-btn').attr('data-original-title', undoTxt);
      if ($('#planner-undo-btn:hover').length) {
        $('#planner-undo-btn').tooltip('show');
      }

      var redoTxt = ts('p_redo', 'Redo');
      if (this.historyIdx === this.history.length - 1) {
        $('#planner-redo-btn').addClass('planner-button-disabled');
      }
      else {
        redoTxt += " (" + this.history[this.historyIdx + 1].actionName + ")";
      }
      $('#planner-redo-btn').attr('data-original-title', redoTxt);
      if ($('#planner-redo-btn:hover').length) {
        $('#planner-redo-btn').tooltip('show');
      }
    }
  }

  preAll() {
    hideTools();
    unHighlight();
    this.busy = true;
    this.handleButtonClasses();
    startLoading();
  }

  postAll(res) {
    this.busy = false;
    this.handleButtonClasses();
    toastRemoveAll();
    stopLoading();
    if (!res) {
      toastError(ts("p_history_err", "Due to an error, we couldn't finish the last action."));
    }
  }

  redo() {
    if (this.busy || isDevChangeInProgress()) {
      toastInfoSingle(ts("p_history_busy", "Please wait, another operation is in progress."));
    }
    else if (this.historyIdx === this.history.length - 1) {
      toastInfoSingle(ts("p_history_noredo", "Nothing to redo"));
    }
    else {
      var thisVar = this;
      this.preAll();
      var i = 0;
      try {
        this.history[this.historyIdx + 1].execute(function (res) {
          if (i === 0) {
            if (res) {
              thisVar.historyIdx++;
            }
            thisVar.postAll(res);
          }
          else {
            console.warn('HISTORY: Someone called their Redo callback multiple times:', i + 1);
          }
          i++;
        });
      } catch (e) {
        console.error(e);
        thisVar.postAll(false);
      }
    }
  }

  undo() {
    if (this.busy || isDevChangeInProgress()) {
      toastInfoSingle(ts("p_history_busy", "Please wait, another operation is in progress."));
    }
    else if (this.historyIdx === -1) {
      toastInfoSingle(ts("p_history_noundo", "Nothing to undo"));
    }
    else {
      var thisVar = this;
      this.preAll();
      var i = 0;
      try {
        this.history[this.historyIdx].undo(function (res) {
          if (i === 0) {
            if (res) {
              thisVar.historyIdx--;
            }
            thisVar.postAll(res);
          }
          else {
            console.warn('HISTORY: Someone called their Undo callback multiple times:', i + 1);
          }
          i++;
        });
      } catch (e) {
        console.error(e);
        thisVar.postAll(false);
      }
    }
  }

  /**
   *
   * @param {PlannerAction} action
   */
  addHistoryEntry(action) {
    if (action.error) {
      console.warn('didnt add action entry since it contained an error.', action, PlannerGlobals.plannerHistoryManager.history);
      return;
    }
    this.historyIdx++;
    this.history.splice(this.historyIdx);
    this.history.push(action);
    if (this.history.length > 50) {
      this.history.splice(0, 1);
      this.historyIdx--;
    }
    this.handleButtonClasses();
  }

  resetHistory() {
    this.debug && console.debug('DEBUG: History reset');
    /**
     * @type {PlannerAction[]}
     */
    this.history = [];
    this.historyIdx = -1;
    this.busy = false;
    this.handleButtonClasses();
  }
  equalAsString(a, b) {
    if (this.debug && (typeof a === "undefined" || typeof b === "undefined")) {
      console.warn("HISTORY: received undefined argument for comparison");
    }
    return ("" + a) === ("" + b);
  }
  deviceIdChanged(from, to) {
    if (this.equalAsString(from, to)) { return; }
    this.debug && console.debug('DEBUG: deviceId Changed from', from, 'to', to, 'in history entries.');
    this.history.forEach(function (action) {
      action.deviceIdChanged(from, to);
    });
  }
  roomIdChanged(from, to) {
    if (this.equalAsString(from, to)) { return; }
    this.debug && console.debug('DEBUG: roomId Changed from', from, 'to', to, 'in history entries.');
    this.history.forEach(function (action) {
      action.roomIdChanged(from, to);
    });
    if (typeof PlannerGlobals.wallSegmentation === "object" && PlannerGlobals.wallSegmentation && typeof PlannerGlobals.wallSegmentation.roomIdChanged === "function") {
      PlannerGlobals.wallSegmentation.roomIdChanged(from, to);
    }
  }
  serialIdChanged(from, to) {
    if (this.equalAsString(from, to)) { return; }
    this.debug && console.debug('DEBUG: serialId Changed from', from, 'to', to, 'in history entries.');
    this.history.forEach(function (action) {
      action.serialIdChanged(from, to);
    });
  }
  serialConnectionIdChanged(from, to) {
    if (this.equalAsString(from, to)) { return; }
    this.debug && console.debug('DEBUG: serialConnectionId Changed from', from, 'to', to, 'in history entries.');
    this.history.forEach(function (action) {
      action.serialConnectionIdChanged(from, to);
    });
  }
  noteIdChanged(from, to) {
    if (this.equalAsString(from, to)) { return; }
    this.debug && console.debug('DEBUG: noteId Changed from', from, 'to', to, 'in history entries.');
    this.history.forEach(function (action) {
      action.noteIdChanged(from, to);
    });
  }
  measurementIdChanged(from, to) {
    if (this.equalAsString(from, to)) { return; }
    this.debug && console.debug('DEBUG: measurementId Changed from', from, 'to', to, 'in history entries.');
    this.history.forEach(function (action) {
      action.measurementIdChanged(from, to);
    });
  }
  wallModConnIdChanged(from, to) {
    if (this.equalAsString(from, to)) { return; }
    this.debug && console.debug('DEBUG: wallModConnId Changed from', from, 'to', to, 'in history entries.');
    this.history.forEach(function (action) {
      action.wallModConnIdChanged(from, to);
    });
  }
  wallModIdChanged(from, to) {
    if (this.equalAsString(from, to)) { return; }
    this.debug && console.debug('DEBUG: wallModId Changed from', from, 'to', to, 'in history entries.');
    this.history.forEach(function (action) {
      action.wallModIdChanged(from, to);
    });
  }
  wallIdChanged(from, to) {
    if (this.equalAsString(from, to)) { return; }
    this.debug && console.debug('DEBUG: wallId Changed from', from, 'to', to, 'in history entries.');
    this.history.forEach(function (action) {
      action.wallIdChanged(from, to);
    });
  }
}

export class MultiPlannerAction extends PlannerAction {
  /**
   *
   * @param {PlannerAction[]} actions
   */
  constructor(actions) {
    super();
    this.actions = actions;
    if (!Array.isArray(this.actions) || this.actions.length === 0) {
      throw "No actions given to MultiPlannerAction!";
    }
    this.actionName = this.actions[this.actions.length - 1].actionName;
  }
  execute(callback) {
    this.executeRecursively(0, callback);
  }
  undo(callback) {
    this.undoRecursively(this.actions.length - 1, callback);
  }
  executeRecursively(idx, callback) {
    if (idx === this.actions.length) {
      callIfFn(callback, true);
      return;
    }
    var thisVar = this;
    this.actions[idx].execute(function (res) {
      if (res) {
        thisVar.executeRecursively(idx + 1, callback);
      }
      else {
        callIfFn(callback, false);
      }
    });
  }
  undoRecursively(idx, callback) {
    if (idx === -1) {
      callIfFn(callback, true);
      return;
    }
    var thisVar = this;
    this.actions[idx].undo(function (res) {
      if (res) {
        thisVar.undoRecursively(idx - 1, callback);
      }
      else {
        callIfFn(callback, false);
      }
    });
  }
  noteIdChanged(from, to) {
    this.actions.forEach(action => action.noteIdChanged(from, to));
  }
  roomIdChanged(from, to) {
    this.actions.forEach(action => action.roomIdChanged(from, to));
  }
  wallIdChanged(from, to) {
    this.actions.forEach(action => action.wallIdChanged(from, to));
  }
  deviceIdChanged(from, to) {
    this.actions.forEach(action => action.deviceIdChanged(from, to));
  }
  serialIdChanged(from, to) {
    this.actions.forEach(action => action.serialIdChanged(from, to));
  }
  wallModIdChanged(from, to) {
    this.actions.forEach(action => action.wallModIdChanged(from, to));
  }
  measurementIdChanged(from, to) {
    this.actions.forEach(action => action.measurementIdChanged(from, to));
  }
  wallModConnIdChanged(from, to) {
    this.actions.forEach(action => action.wallModConnIdChanged(from, to));
  }
}

export const plannerHistoryHelper = {
  equalAsString(a, b) {
    if (this.debug && (typeof a === "undefined" || typeof b === "undefined")) {
      console.warn("HISTORY: received undefined argument for comparison");
    }
    return ("" + a) === ("" + b);
  },
  /**
   *
   * @param {number | string} from
   * @param {number | string} to
   * @param {D3Device[]} d3Devs
   */
  updateD3DevicesDevIds(from, to, d3Devs) {
    d3Devs.forEach(function (d3Dev) {
      plannerHistoryHelper.updateD3DeviceDevIds(from, to, d3Dev);
      if (d3Dev.connId) {
        d3Dev.serials.forEach(ser => {
          plannerHistoryHelper.updateD3DeviceDevIds(from, to, ser.serObj);
        });
      }
    });
  },
  /**
   *
   * @param {number | string} from
   * @param {number | string} to
   * @param {D3Device[]} d3Devs
   */
  updateD3DevicesSerialIds(from, to, d3Devs) {
    d3Devs.forEach(function (d3Dev) {
      if (d3Dev.connId) {
        d3Dev.serials.forEach(ser => {
          if (ser.id == from) {
            ser.id = to;
            ser.serialId = to;
            ser.serObj.id = to;
          }
        });
      }
      else if (d3Dev.id && d3Dev.id == from) {
        d3Dev.id = to;
      }
    });
  },
  /**
   *
   * @param {number | string} from
   * @param {number | string} to
   * @param {D3Device} d3Dev
   */
  updateD3DeviceDevIds(from, to, d3Dev) {
    d3Dev.devices.forEach(function (dev) { plannerHistoryHelper.updateDeviceDevIds(from, to, dev); });
  },
  /**
   *
   * @param {number | string} from
   * @param {number | string} to
   * @param {Device} device
   */
  updateDeviceDevIds(from, to, device) {
    if (this.equalAsString(from, device.deviceId)) {
      device.deviceId = to;
    }
    if (Array.isArray(device.similarDeviceIds)) {
      for (var i = 0; i < device.similarDeviceIds.length; i++) {
        if (this.equalAsString(from, device.similarDeviceIds[i])) {
          device.similarDeviceIds[i] = to;
        }
      }
    }
  },
  updateMatStateRoomId(from, to, matState) {
    if (typeof matState === "object" && matState) {
      if ('material_layer' in matState && Array.isArray(matState.material_layer)) {
        const poly = matState.material_layer.find(x => x.id == 'ceiling_' + from);
        if (poly) {
          poly.id = 'ceiling_' + to;
        }
      }
      if ('material_splitted_lines' in matState && typeof matState.material_splitted_lines === "object" && matState.material_splitted_lines) {
        const fromKey = 'room_id_' + from;
        const toKey = 'room_id_' + to;
        if (fromKey in matState.material_splitted_lines) {
          matState.material_splitted_lines[toKey] = matState.material_splitted_lines[fromKey];
          delete matState.material_splitted_lines[fromKey];
        }
      }
    }
  },
  /**
   *
   * @param {string | number} from
   * @param {string | number} to
   * @param {MeasurementConnection[]} measArr
   */
  updateMeasurementDeviceIds(from, to, measArr) {
    if (!Array.isArray(measArr)) {
      return console.warn('HISTORY: Invalid measurement array given for wallId update!');
    }
    measArr.forEach(function (measurement) {
      if (!measurement) { return; }
      [measurement.source, measurement.target].forEach(function (tar) {
        if (tar.type === measureTypeById_T(MEASURE_TYPES.userCustomItem) && from.toString().indexOf('C_') === 0) {
          var fromId = from.toString().replace('C_', '');
          if (+fromId === +tar.id) {
            var toId = +to.toString().replace('C_', '');
            tar.id = toId;
          }
        }
        else if (tar.type === measureTypeById_T(MEASURE_TYPES.device) && from.toString().indexOf('C_') === -1) {
          if (+from === +tar.id) {
            tar.id = to;
          }
        }
      });
    });
  },
  /**
   *
   * @param {string | number} from
   * @param {string | number} to
   * @param {MeasurementConnection[]} measArr
   */
  updateMeasurementSerialIds(from, to, measArr) {
    if (!Array.isArray(measArr)) {
      return console.warn('HISTORY: Invalid measurement array given for wallId update!');
    }
    measArr.forEach(function (measurement) {
      if (!measurement) { return; }
      [measurement.source, measurement.target].forEach(function (tar) {
        if (tar.type === measureTypeById_T(MEASURE_TYPES.serial) && +from === +tar.id) {
          tar.id = +to;
        }
      });
    });
  },
  /**
   *
   * @param {string | number} from
   * @param {string | number} to
   * @param {SerialConnection[]} array
   */
  updateSerialConnectionId(from, to, array) {
    if (!Array.isArray(array)) {
      return console.warn('HISTORY: Invalid serialConnection array given for id update!');
    }
    array.forEach(conn => {
      if (!conn) { return; }
      if (this.equalAsString(from, conn.id)) {
        conn.id = to;
      }
    });
  },
  /**
   *
   * @param {string | number} from
   * @param {string | number} to
   * @param {SerialConnection[]} array
   */
  updateSerialIdInConnections(from, to, array) {
    if (!Array.isArray(array)) {
      return console.warn('HISTORY: Invalid serialConnection array given for id update!');
    }
    array.forEach(conn => {
      if (!conn) { return; }
      conn.serialIds.forEach((serId, idx, arr) => {
        if (this.equalAsString(serId, from)) {
          arr[idx] = to;
        }
      });
    });
  },
  /**
   *
   * @param {string | number} from
   * @param {string | number} to
   * @param {MeasurementConnection[]} measArr
   */
  updateMeasurementWallModIds(from, to, measArr) {
    if (!Array.isArray(measArr)) {
      return console.warn('HISTORY: Invalid measurement array given for wallId update!');
    }
    measArr.forEach(function (measurement) {
      if (!measurement) { return; }
      [measurement.source, measurement.target].forEach(function (tar) {
        if (tar.type === measureTypeById_T(MEASURE_TYPES.wallMod) && +from === +tar.id) {
          tar.id = +to;
        }
      });
    });
  },
  /**
   *
   * @param {string | number} from
   * @param {string | number} to
   * @param {MeasurementConnection[]} measArr
   */
  updateMeasurementWallIds(from, to, measArr) {
    if (!Array.isArray(measArr)) {
      return console.warn('HISTORY: Invalid measurement array given for wallId update!');
    }
    measArr.forEach(function (measurement) {
      if (!measurement) { return; }
      [measurement.source, measurement.target].forEach(function (tar) {
        if (tar.type === measureTypeById_T(MEASURE_TYPES.wall) && +from === +tar.id) {
          tar.id = +to;
        }
      });
    });
  },
  /**
   *
   * @param {RemovedDevParams[]} params
   * @param {number} idx
   * @param {function} cb
   */
  placeDevsIntoAllGroups(params, idx = 0, cb) {
    if (idx >= params.length) {
      if (typeof cb === "function") { cb(true); }
    }
    else {
      var param = params[idx];

      plannerHistoryHelper.placeDevIntoAllGroups(param.device.deviceId, param.groups, 0, function (res) {
        if (res) { plannerHistoryHelper.placeDevsIntoAllGroups(params, idx + 1, cb); }
        else { if (typeof cb === "function") { cb(false); } }
      });
    }
  },
  /**
   * Place a device into all supplied groups
   * @param {number} deviceId
   * @param {Group[]} groups
   * @param {number} idx
   * @param {function} cb
   */
  placeDevIntoAllGroups(deviceId, groups, idx = 0, cb) {
    if (idx >= groups.length) {
      if (typeof cb === "function") { cb(true); }
    }
    else {
      var grp = groups[idx];
      // get the suitable target devices - got ghosts and not the same as the source
      var firstOtherDevices = grp.deviceIds
      .map(getDeviceById)
      .filter(function (dev) { return !dev.deleted && !dev.ghost && dev.deviceId != deviceId; });

      // if there are candidates ...
      if (firstOtherDevices.length) {
        // check if there is a target device that only has one group
        // because connecting to a target that has more than one group can be ambiguous
        var firstOtherDevice = firstOtherDevices.find(function (dev) {
          return getGroupsOfDevice(dev.deviceId).length === 1;
        }) || firstOtherDevices[0]; // otherwise, take the first candidate
        // if there is a candidate ...
        if (firstOtherDevice) {
          var tarGroup = getGroupOfDevice(firstOtherDevice.deviceId);
          // if the target is in a group, add this to the target group
          if (tarGroup) {
            addDevToGroupNoCheck(deviceId, firstOtherDevice.deviceId, function () {
              plannerHistoryHelper.placeDevIntoAllGroups(deviceId, groups, idx + 1, cb);
            }, function () {
              if (typeof cb === "function") { cb(false); }
            });
          }
          // if the target is not grouped, create a new group from these two devs
          else {
            makeNewGroupNoCheck(deviceId, firstOtherDevice.deviceId, function () {
              plannerHistoryHelper.placeDevIntoAllGroups(deviceId, groups, idx + 1, cb);
            }, function () {
              if (typeof cb === "function") { cb(false); }
            });
          }
        }
        else {
          if (typeof cb === "function") { cb(false); }
        }
      }
      else {
        if (typeof cb === "function") { cb(true); }
      }
    }
  },
  applyWallMats(saveData) {
    return PlannerGlobals.wallSegmentation.recalcPreserveSave(saveData, true).then(preserved => {
      if (preserved) {
        return PlannerGlobals.wallSegmentation.saveState(PlannerGlobals.wallSegmentation.getSaveDataV2());
      }
      else {
        return PlannerGlobals.wallSegmentation.saveState(PlannerGlobals.wallSegmentation.getEmptySaveDataV2());
      }
    });
  },
  /**
   * Send all given groups, and wait for the previous completion before sending the next one
   * @param {Group[]} groups
   * @param {number} currIdx
   * @param {function} cb
   * @param {function} errCb
   */
  applyGroupStructure(groups, currIdx, cb, errCb) {
    if (currIdx >= groups.length) {
      if (typeof cb === "function") {
        cb();
      }
      return;
    }
    if (currIdx === 0) {
      groups = groups.map(function (group) {
        var groupDevs = group.deviceIds.map(getDeviceById);
        var notInGroupIds = group.deviceIds.filter(function (dId) { return !getGroupOfDevice(dId); }).map(function (dId) { return +dId; });

        var existingDevConnectionType;
        var existingDevToConnectTo = groupDevs.find(function (dev) {
          var devGroupNum = getGroupsOfDevice(dev.deviceId).length;
          return !dev.input && devGroupNum === 1;
        });
        if (existingDevToConnectTo) {
          existingDevConnectionType = "addToExisting";
        }
        else {
          var existingDevToConnectTo = groupDevs.find(function (dev) {
            var devGroupNum = getGroupsOfDevice(dev.deviceId).length;
            return dev.input && devGroupNum === 1;
          });
          if (existingDevToConnectTo) {
            var grp = getGroupOfDevice(existingDevToConnectTo.deviceId);
            if (groupIsControlledByNSwitches(grp) === grp.deviceIds.length) {
              existingDevConnectionType = "addToExisting";
            }
            else {
              existingDevConnectionType = "createNew";
            }
          }
        }

        if (existingDevToConnectTo) {
          notInGroupIds.unshift(existingDevToConnectTo.deviceId);
        }

        return { id: group.id, deviceIds: notInGroupIds, existingDevConnectionType };
      });
    }

    var grp = groups[currIdx];

    plannerHistoryHelper.chainGroupDevs(grp.deviceIds, 0, grp.existingDevConnectionType, function () {
      plannerHistoryHelper.applyGroupStructure(groups, currIdx + 1, cb, errCb);
    }, function () {
      if (typeof errCb === "function") {
        errCb();
      }
    });
  },

  /**
   *
   * @param {number[]} ids
   * @param {number} currIdx
   * @param {"createNew" | "addToExisting" | undefined} existingDevConnectionType
   * @param {function} cb
   * @param {function} errCb
   */
  chainGroupDevs(ids, currIdx, existingDevConnectionType, cb, errCb) {
    if (currIdx + 1 >= ids.length) {
      if (typeof cb === "function") {
        cb();
      }
      return;
    }

    if (currIdx === 0) {
      if (existingDevConnectionType === "addToExisting") {
        addDevToGroupNoCheck(ids[currIdx + 1], ids[currIdx], function () {
          plannerHistoryHelper.chainGroupDevs(ids, currIdx + 1, existingDevConnectionType, cb, errCb);
        }, function () {
          if (typeof errCb === "function") {
            errCb();
          }
        });
      }
      else {
        makeNewGroupNoCheck(ids[currIdx + 1], ids[currIdx], function () {
          plannerHistoryHelper.chainGroupDevs(ids, currIdx + 1, existingDevConnectionType, cb, errCb);
        }, function () {
          if (typeof errCb === "function") {
            errCb();
          }
        });
      }
    }
    else {
      var srcDevId = ids[currIdx + 1];
      var tarDevId = ids[currIdx];
      var tarDevOverride = ids.map(getDeviceById).find(function (dev) {
        return !dev.input && getGroupsOfDevice(dev.deviceId).length === 1;
      });
      if (tarDevOverride) { tarDevId = tarDevOverride.deviceId; }

      addDevToGroupNoCheck(srcDevId, tarDevId, function () {
        plannerHistoryHelper.chainGroupDevs(ids, currIdx + 1, existingDevConnectionType, cb, errCb);
      }, function () {
        if (typeof errCb === "function") {
          errCb();
        }
      });
    }
  },
  /**
   *
   * @param {WallModConn[]} wallModConns
   * @param {number} currIdx
   * @param {function} cb
   * @param {function} errCb
   * @param {Object.<number,number>} idChangeTo
   */
  chainSendWallModConns(wallModConns, currIdx = 0, cb, errCb, idChangeTo = {}) {
    if (currIdx >= wallModConns.length) {
      if (typeof cb === "function") {
        cb();
      }
      return;
    }
    var currWMC = wallModConns[currIdx];
    currWMC.isAJAXWait = true;
    PlannerGlobals.wallModConnections.push(currWMC);
    var preId = currWMC.id;
    var roomsPreId = currWMC.rooms.map(function (wm) { return wm.id });
    wallModHelperDOM.sendWallMod(currWMC, function (res) {
      idChangeTo[preId] = res.id;
      res.rooms.forEach(function (wm, idx) {
        PlannerGlobals.plannerHistoryManager.wallModIdChanged(roomsPreId[idx], wm.id);
      });
      plannerHistoryHelper.chainSendWallModConns(wallModConns, currIdx + 1, cb, errCb, idChangeTo);
    }, function () {
      if (typeof errCb === "function") {
        errCb();
      }
    });
  },
  /**
   *
   * @param {MeasurementConnection[]} measConns
   */
  distinctMeasurements(measConns) {
    var alreadySeen = {};
    var res = [];
    measConns.forEach(function (meas) {
      var id = 'st' + meas.source.type + "sid" + meas.source.id + "tt" + meas.target.type + "tid" + meas.target.id;
      if (!alreadySeen[id]) {
        res.push(meas);
        alreadySeen[id] = true;
      }
    })
    return res;
  },
  /**
   *
   * @param {Device[]} devices
   * @param {number} idx
   * @param {function} callback
   * @param {function} errorCallback
   */
  chainPlaceDevices(devices, idx = 0, callback, errorCallback) {
    if (idx >= devices.length) {
      if (typeof callback === "function") {
        removeProgressBar();
        callback(true);
      }
      redrawDevices();
      return;
    }
    setProgressBarState(idx / devices.length * 100);
    var sourceDevice = devices[idx];
    var preDevId = sourceDevice.deviceId;
    var preSerId = sourceDevice.targetSerialId;
    var targetSerial = sourceDevice.targetSerialId && !sourceDevice.alone ? getSerialById(sourceDevice.targetSerialId) : null;
    var product = getProductOfDevice(sourceDevice);
    placeDevice(sourceDevice.x, sourceDevice.y, sourceDevice.roomId, product, function (placeRespDev, resp, serial) {
      if (placeRespDev) {
        sourceDevice.deviceId = placeRespDev.deviceId;
        /* redrawDevice(sourceDevice.deviceId); */
        if (preDevId) {
          PlannerGlobals.plannerHistoryManager.deviceIdChanged(preDevId, placeRespDev.deviceId);
        }

        if (preSerId && serial && sourceDevice.alone) {
          PlannerGlobals.plannerHistoryManager.serialIdChanged(preSerId, serial.id);
          serial.height = sourceDevice.serHeight;
          serial.direction = sourceDevice.serDirection;
          ajaxSetSerialProps(serial);
        }

        if (sourceDevice.noteId) {
          var origiNoteId = sourceDevice.noteId;
          sendDevNoteAuto(placeRespDev.deviceId, sourceDevice.noteTxt, sourceDevice.noteColor, function (noteRespDev) {
            if (noteRespDev) {
              PlannerGlobals.plannerHistoryManager.noteIdChanged(origiNoteId, noteRespDev.noteId);
              plannerHistoryHelper.chainPlaceDevices(devices, idx + 1, callback, errorCallback);
            }
            else {
              redrawDevices();
              removeProgressBar();
              if (typeof errorCallback === "function") {
                errorCallback();
              }
            }
          });
        }
        else {
          plannerHistoryHelper.chainPlaceDevices(devices, idx + 1, callback, errorCallback);
        }
      }
      else {
        redrawDevices();
        removeProgressBar();
        if (typeof errorCallback === "function") {
          errorCallback();
        }
      }
    }, sourceDevice.alone, targetSerial, sourceDevice.angle, true, undefined, undefined, true);
  },
  /**
   *
   * @param {D3Device[]} d3Devs
   * @param {number} idx
   * @param {function} cb
   * @param {function} errCb
   */
  chainPlaceD3Serials(d3Devs, idx = 0, cb, errCb, gatherArr) {
    if (!gatherArr) { gatherArr = []; }

    if (idx >= d3Devs.length) {

      gatherArr.forEach(elem => {
        PlannerGlobals.plannerHistoryManager.serialIdChanged(elem.from, elem.from + "_ori");
      });

      gatherArr.forEach(elem => {
        PlannerGlobals.plannerHistoryManager.serialIdChanged(elem.from + "_ori", elem.to);
      });

      if (typeof cb === "function") {
        cb();
      }
      return;
    }

    var d3d = d3Devs[idx];

    var mappedDevs = [];

    d3d.devices.forEach(function (dev) {
      if (Array.isArray(dev.similarDeviceIds)) {
        dev.similarDeviceIds.forEach(function (dId, idx) {
          var clonedDev = deepCopy(dev);
          clonedDev.deviceId = dId;
          if (idx > 0) {
            delete clonedDev.removedDevParams;
          }
          mappedDevs.push(clonedDev);
        });
      }
      else {
        mappedDevs.push(dev);
      }
    });

    var prods = mappedDevs.map(dev => {
      const prod = Object.assign({}, getProductOfDevice(dev));
      if (!dev.noteTxt) {
        prod.prevent_note = true;
      }
      return prod;
    });
    var serPreId = d3d.id;
    var preDevIds = mappedDevs.map(function (d) { return d.deviceId; });
    placeSerialDevices(d3d.x, d3d.y, d3d.roomId, prods, d3d.angle, true, d3d.height, d3d.direction)
    .done(function (newSer) {
      /* plannerHistoryManager.serialIdChanged(serPreId, newSer.id); */
      gatherArr.push({ from: serPreId, to: newSer.id });

      var postDevIds = getSerialById(newSer.id).deviceIds;

      postDevIds.forEach(function (id, idx) {
        PlannerGlobals.plannerHistoryManager.deviceIdChanged(preDevIds[idx], id);
      });

      plannerHistoryHelper.chainPlaceD3Serials(d3Devs, idx + 1, cb, errCb, gatherArr);
    })
    .fail(function () {
      if (typeof errCb === "function") {
        errCb();
      }
    });
  },
  /**
   *
   * @param {Object.<number, boolean>} roomsDict
   */
  startPulseRooms(roomsDict) {
    for (var key in roomsDict) {
      $('.poly[data-roomId="' + key + '"]').addClass('pulsing');
    }
  },
  /**
   *
   * @param {Object.<number, boolean>} roomsDict
   */
  stopPulseRooms(roomsDict) {
    for (var key in roomsDict) {
      $('.poly[data-roomId="' + key + '"]').removeClass('pulsing');
    }
  },
  placeDevAndUpdateIds(dev, defArr) {
    var prod = getProductOfDevice(dev);
    var def = $.Deferred();
    defArr.push(def);
    var preId = dev.deviceId;
    if (!dev.noteTxt) {
      prod = Object.assign({}, prod);
      prod.prevent_note = true;
    }
    placeDevice(dev.x, dev.y, dev.roomId, prod, function (res) {
      if (res) {
        dev.deviceId = res.deviceId;
        PlannerGlobals.plannerHistoryManager.deviceIdChanged(preId, res.deviceId);
        def.resolve();
      }
      else {
        def.reject();
      }
    }, true, null, dev.angle, true);
  },
  /**
   *
   * @param {SerialConnection} serialConnection
   */
  setOlderSerialAsTargetInConnection(serialConnection) {
    serialConnection.serialIds.sort((a, b) => b - a);
  },
  /**
   *
   * @param {SerialConnection[]} serialConnections
   */
  applySerialConnections(serialConnections) {
    return serialConnections.reduce((prevPromise, conn) => {
      return prevPromise.finally(() => {
        return new Promise((res, rej) => {
          if (conn.serialIds.length < 2) {
            return rej();
          }
          const connExists = conn.serialIds.every(serId => getSerialConnectionForSerialId(serId));
          if (connExists) {
            return res();
          }

          const origiId = conn.id;

          connectSerials(conn.serialIds[0], conn.serialIds[1])
          .then(result => {
            PlannerGlobals.plannerHistoryManager.serialConnectionIdChanged(origiId, result.newId);

            return res();
          })
          .catch(() => rej());

        });
      });
    }, Promise.resolve());

    /* const proms = serialConnections.map(conn => {
        return new Promise((res, rej) => {
            if (conn.serialIds.length < 2) {
                return rej();
            }
            const connExists = conn.serialIds.every(serId => getSerialConnectionForSerialId(serId));
            if (connExists) {
                return res();
            }

            const origiId = conn.id;

            connectSerials(conn.serialIds[0], conn.serialIds[1])
                .then(result => {
                    plannerHistoryManager.serialConnectionIdChanged(origiId, result.newId);

                    return res();
                })
                .catch(() => rej());

        });
    });
    return Promise.all(proms); */
  },
  /**
   *
   * @param {D3Device[]} d3Devs
   * @param {WallModConnection[]} wallModConns
   * @param {Group[]} affectedGroups
   * @param {MeasurementConnection[]} removedMeasurements
   * @param {object} matSaveState
   * @param {SerialConnection[]} serialConnections
   */
  placeEntities(d3Devs, wallModConns, affectedGroups, removedMeasurements, matSaveState, serialConnections) {
    if (!Array.isArray(d3Devs)) { console.warn('HISTORY: d3Devs received invalid argument, replacing with empty array.', d3Devs); d3Devs = []; }
    if (!Array.isArray(wallModConns)) { console.warn('HISTORY: wallModConns received invalid argument, replacing with empty array.', wallModConns); wallModConns = []; }
    if (!Array.isArray(affectedGroups)) { console.warn('HISTORY: affectedGroups received invalid argument, replacing with empty array.', affectedGroups); affectedGroups = []; }
    if (!Array.isArray(removedMeasurements)) { console.warn('HISTORY: removedMeasurements received invalid argument, replacing with empty array.', removedMeasurements); removedMeasurements = []; }
    if (typeof matSaveState !== "object") { console.warn('HISTORY: matSaveState received invalid argument, replacing with null.', matSaveState); matSaveState = null; }
    if (!Array.isArray(serialConnections)) { console.warn('HISTORY: serialConnections received invalid argument, replacing with empty array.', serialConnections); serialConnections = []; }

    /* $('#svgAndChat').addClass('pulsing'); */

    var affectedRooms = {};
    d3Devs.forEach(function (d3d) {
      affectedRooms[d3d.roomId] = true;
    });
    plannerHistoryHelper.startPulseRooms(affectedRooms);

    // STAGE 1 - DEVICES
    var devDefs = [];
    var serialD3s = [];
    var devsToPlaceAfter = [];
    d3Devs.forEach(function (d3d) {
      if (d3d.connId) {
        d3d.serials.forEach(ser => {
          serialD3s.push(ser.serObj);
        });
      }
      else if (d3d.id) {
        serialD3s.push(d3d);
      }
      else {
        // PUT BACK DEVICES
        var dev = d3d.devices[0];

        if (Array.isArray(dev.similarDeviceIds)) {
          dev.similarDeviceIds.forEach(function (dId, idx) {
            if (idx > 0) {
              var clonedDev = deepCopy(dev);
              clonedDev.deviceId = dId;
              delete clonedDev.removedDevParams;
              devsToPlaceAfter.push(clonedDev);
            }
          });
        }

        plannerHistoryHelper.placeDevAndUpdateIds(dev, devDefs);
      }
    });

    // PUT BACK SERIALS
    var serDef = $.Deferred();
    plannerHistoryHelper.chainPlaceD3Serials(serialD3s, 0, function () {
      serDef.resolve();
    }, function () {
      serDef.reject();
    });

    devDefs.push(serDef);

    redrawDevices(); // draw ghosts

    // STAGE 2 - WALLMODS
    var wmcDef = $.Deferred();

    plannerHistoryHelper.chainSendWallModConns(wallModConns, 0, function () {
      wmcDef.resolve();
    }, function () {
      wmcDef.reject();
    });

    // STAGE 3 - GROUPS/MEASUREMENTS/NOTES
    var finalDef = $.Deferred();

    $.when.apply($, devDefs.concat([wmcDef]))
    .done(function () {
      var finalDefs = [];

      devsToPlaceAfter.forEach(function (dev) { plannerHistoryHelper.placeDevAndUpdateIds(dev, finalDefs); });
      redrawDevices(); // draw ghosts

      var measuresToPutBack = removedMeasurements;

      d3Devs.forEach(function (d3d) {
        // COLLECT DEV MEASURES
        var measures = d3d.removedMeasures;
        d3d.devices.forEach(function (dev) {
          measures = measures.concat(dev.removedDevParams.removedMeasures);
        });

        measuresToPutBack = measuresToPutBack.concat(measures);

        d3d.devices.forEach(function (dev) {
          // PUT BACK NOTES
          if (dev.removedDevParams.note) {
            var note = dev.removedDevParams.note;
            var oriNoteId = note.note_id;
            function noteCb(dev) {
              if (dev) {
                PlannerGlobals.plannerHistoryManager.noteIdChanged(oriNoteId, dev.noteId);
                def.resolve();
              }
              else {
                def.reject();
              }
            }
            var def = $.Deferred();
            finalDefs.push(def);
            var placedDev = getDeviceById(dev.deviceId);
            if (placedDev.noteId) {
              modDevNote(placedDev, note.color, note.text, noteCb);
            }
            else {
              sendDevNoteAuto(dev.deviceId, note.text, note.color, noteCb);
            }
          }
        });
      });

      // PUT BACK MEASUREMENTS
      finalDefs.push(plannerHistoryHelper.putBackMeasurementConns(plannerHistoryHelper.distinctMeasurements(measuresToPutBack)));

      // PUT BACK GROUPS
      let groupsDef = $.Deferred();
      finalDefs.push(groupsDef);

      plannerHistoryHelper.applyGroupStructure(affectedGroups, 0, function () {
        groupsDef.resolve();
      }, function () {
        groupsDef.reject();
      });

      if (typeof matSaveState === "object" && matSaveState) {
        let matStateDef = $.Deferred();
        finalDefs.push(matStateDef);
        plannerHistoryHelper.applyWallMats(matSaveState)
        .then(() => {
          matStateDef.resolve();
        })
        .catch(() => {
          matStateDef.reject();
        });
      }

      // PUT BACK SERIAL CONNECTIONS
      let serialConnDef = $.Deferred();
      finalDefs.push(serialConnDef);
      serialConnections.forEach(conn => plannerHistoryHelper.setOlderSerialAsTargetInConnection(conn));
      plannerHistoryHelper.applySerialConnections(serialConnections)
      .then(() => {
        serialConnDef.resolve();
      })
      .catch(() => {
        serialConnDef.reject();
      });

      $.when.apply($, finalDefs)
      .done(function () {
        finalDef.resolve();
      })
      .fail(function () {
        finalDef.reject();
      });
    })
    .fail(function () {
      finalDef.reject();
    });

    finalDef.always(function () {
      plannerHistoryHelper.stopPulseRooms(affectedRooms);
      setTimeout(function () {
        refreshFloorView();
      }, 500);
      redrawDevices();
    });

    return finalDef;
  },
  /**
   *
   * @param {MeasurementConnection[]} measures
   * @returns {JQuery.Promise<any,any,any>}
   */
  putBackMeasurementConns(measures) {
    var defs = [];
    measures.forEach(function (meas) {
      let measDef = $.Deferred();
      defs.push(measDef);
      meas.sentToServerPromise = $.Deferred();
      meas.justAdded = true;
      meas.justDeleted = false;
      PlannerGlobals.measurements.push(meas);
      let oriId = meas.id;
      addMeasurementAjax(meas, function (meas) {
        PlannerGlobals.plannerHistoryManager.measurementIdChanged(oriId, meas.id);
        measDef.resolve();
      }, function () {
        measDef.reject();
      });
    });
    return $.when.apply($, defs);
  }
}

export class EntityPlacerBuilder {
  constructor() {
    this.d3Devs = [];
    this.wallModConns = [];
    this.removedGroups = [];
    this.removedMeasurements = [];
    this.matSaveState = null;
    this.serialConnections = [];
  }
  setD3Devs(d3Devs) {
    this.d3Devs = d3Devs;
    return this;
  }
  setWallModConns(wallModConns) {
    this.wallModConns = wallModConns;
    return this;
  }
  setGroups(removedGroups) {
    this.removedGroups = removedGroups;
    return this;
  }
  setMeasurements(removedMeasurements) {
    this.removedMeasurements = removedMeasurements;
    return this;
  }
  setMatSaveState(matSaveState) {
    this.matSaveState = matSaveState;
    return this;
  }

  setSerialConnections(serialConnections) {
    this.serialConnections = serialConnections;
    return this;
  }

  areParamsEmpty() {
    const devsEmpty = Array.isArray(this.d3Devs) && !this.d3Devs.length;
    const wallModsEmpty = Array.isArray(this.wallModConns) && !this.wallModConns.length;
    const groupsEmpty = Array.isArray(this.removedGroups) && !this.removedGroups.length;
    const measuresEmpty = Array.isArray(this.removedMeasurements) && !this.removedMeasurements.length;
    const matSaveEmpty = this.matSaveState === null || typeof this.matSaveState === "object" && (!this.matSaveState || !Object.keys(this.matSaveState).length);
    const serialConnsEmpty = Array.isArray(this.serialConnections) && !this.serialConnections.length;

    return devsEmpty && wallModsEmpty && groupsEmpty && measuresEmpty && matSaveEmpty && serialConnsEmpty;
  }

  run() {
    if (this.areParamsEmpty()) {
      console.debug('skipping history entity placement, because no valid params given, returning fulfilled promise.');
      const def = $.Deferred();
      def.resolve();
      return def;
    }
    return plannerHistoryHelper.placeEntities(this.d3Devs, this.wallModConns, this.removedGroups, this.removedMeasurements, this.matSaveState, this.serialConnections);
  }
}
